module.exports = __webpack_public_path__ + "static/media/light_globe.46e842ca.svg";